module.exports = __webpack_public_path__ + "static/media/google-play.21f3c6ce.png";